const faqs = [
    {
        id: 1, 
        heading: 'How can I make a reservation at the restaurant?',
        content: 'To make a reservation, you can either book online through our website or call us directly. We recommend booking in advance to secure your preferred dining time, especially during peak hours and weekends.',
    },
    {
        id: 2,
        heading: 'What menu options are available?',
        content: 'Our menu features a diverse selection of dishes, including appetizers, main courses, desserts, and beverages. We also offer vegetarian, vegan, and gluten-free options. Check our menu page for the full selection.',
    },
    {
        id: 3,
        heading: 'Do you offer catering services for events?',
        content: 'Yes, we offer catering services for a variety of events including weddings, corporate functions, and private parties. Contact us to discuss your event needs and let us help you create a memorable dining experience.',
    },
    {
        id: 4,
        heading: 'Can I make special dietary requests?',
        content: 'Absolutely! We are happy to accommodate special dietary requests and allergies. Please inform us of your needs when making your reservation or when ordering, and we will do our best to ensure your dietary requirements are met.',
    },
    {
        id: 5,
        heading: 'What payment options are available?',
        content: 'We accept various payment options including credit/debit cards, mobile payments, and cash. For large parties or events, we can arrange for invoicing if needed. Please contact us for more details.',
    },
];

export default faqs;